import React, { useContext, useState } from 'react'
import { Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import moment from 'moment'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

import Divider from 'components/Divider'
import CashRegisterList from 'components/CashRegisterTree'
import { ItemView, SideList, StyledColList, StyledColItem, FilterContext } from 'components/SectionHandler'
import ContenHeader from 'components/ContenHeader'
import formatDate from 'helpers/dateTimeFormatter'
import { transformData } from 'components/graphql'
import ToggledSideBar from '../../components/ToggledSideBar/ToggledSideBar'
import { useQuery } from 'components/graphql'
import listCashRegisters from 'gql/query/listCashRegisters'

const StyledRow = styled(Row)`
	${StyledColItem} {
		max-width: ${({ withrightblock }) => `calc(100% - ${withrightblock}px)`};
		transition: 0.3s;
		padding-left: ${({ withrightblock }) => +withrightblock ? 'inherit' : '20px !important'};
	}
`

const TotalSection = props => {
	const [t] = useTranslation()
	const { setFilter, ...filters } = useContext(FilterContext)
	const [commonData, setCommonData] = useState({})
	const [displayLeftBlock, setDisplayLeftBlock] = useState(true)
	const theme = useTheme()
	const { section, listQueryRef, sectionData, getRouteById, history, recordId } = props
	const res = useQuery(listCashRegisters)
	const allCRids = res?.data?.listCashRegisters?.map(({ id }) => id) || []
	const baseFilter = {
		period: {
			from: moment.utc().subtract(1, 'days').startOf('day'),
			to: moment.utc().subtract(1, 'days').endOf('day')
		}
	}
	const { cashRegisterIds: filteredCRids, ...filter } = get(filters, section, {})
	const cashRegisterIds = props.appData.shopAccess && !filteredCRids ? allCRids : filteredCRids

	const handleFilter = (values) => {
		setFilter(section, {
			...filter,
			cashRegisterIds,
			...values
		})
	}
	const handleCompleted = (data) => {
		setCommonData(data)
		let redirectPath = ''
		if(!recordId && sectionData.listQuery) {
			try {
				const firstRecord = get(transformData(data, { queryFieldExtract: true }), 'data.items.0', {})
				redirectPath = getRouteById(firstRecord.id)
			} catch (e) {
				throw Error(e)
			}
		} else if(recordId && sectionData.listQuery) {
			// const { total } = data?.cashAssist?.listClosings
			if(data?.cashAssist?.listClosings?.total === 0) {
				history.push({ pathname: `/${section}` })
			}
		}
		return redirectPath ? history.push({ pathname: redirectPath }) : null
	}

	return(
		<StyledRow withrightblock={displayLeftBlock ? '520' : '0'}>
			<ToggledSideBar showBlock={displayLeftBlock} setShowBlock={setDisplayLeftBlock}>
				<StyledColList width={displayLeftBlock ? '520px' : '0px'}>
					<ContenHeader title={t('closing_section.strings.cash_register_filter')} />
					<CashRegisterList
						startConcealed
						startAllActive={!cashRegisterIds}
						activeNodesArr={cashRegisterIds}
						hideNoCRBranches
						cardsInRow={1}
						onChange={(idArr) => handleFilter({ cashRegisterIds: idArr })}
						inverted
					/>
					<Divider/>
					<SideList
						{...props}
						commonData={commonData}
						xs={0}
						fixSidebar={false}
						datatableProps={{
							label: t('closing_section.strings.closing_table'),
							rowMenu: [],
							remoteOptions: {
								queryRef: listQueryRef,
								query: sectionData.listQuery,
								variables: { filter: { cashRegisterIds } },
								withFilter: {
									FilterComponent: sectionData.FilterComponent,
									baseFilter,
									// filterValues: Object.keys(filter).length ? filter : null,
									...!isEqual(filter, baseFilter) && !!Object.keys(filter).length && { filterValues: filter },
									onFilter: handleFilter
								},
								onCompleted: handleCompleted,
								withSort: true
							},
							getTrProps: (_, { original }) => original.inactive ? { style: { background: theme.errorColor } } : {}
						}}
					/>
				</StyledColList>
			</ToggledSideBar>
			<ItemView
				{...props}
				navBarProps={{
					getLabel: data => `${t('closing_section.strings.closing_num')} ${data.number}, ${formatDate(data.dateTime, 'DD.MM.YYYY HH:mm:ss')}`
				}}
				subsectionProps={{
					cashRegisterIds,
					period: Object.keys(filter).length ? filter.period : baseFilter.period,
					queryRef: listQueryRef
				}}
				itemActionsProps={{
					item: {
						cashRegisterIds,
						period: Object.keys(filter).length ? filter.period : baseFilter.period,
						queryRef: listQueryRef
					}
				}}
			/>
		</StyledRow>
	)
}


export default TotalSection
